// src/components/layout/MainLayout.js
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import TopBar from './TopBar';
import Header from './Header';
import Footer from './Footer';
import CookieConsentBanner from '../common/CookieConsentBanner';
import { useLanguage } from '../../contexts/LanguageContext';

function MainLayout({ children }) {
  const { language, changeLanguage } = useLanguage();
  const location = useLocation();

  // Update language based on URL path when location changes
  useEffect(() => {
    const pathParts = location.pathname.split('/').filter(Boolean);
    const langInUrl = pathParts[0];
    
    // If the first part of the URL is a valid language code and different from current language
    if ((langInUrl === 'en' || langInUrl === 'de') && langInUrl !== language) {
      changeLanguage(langInUrl);
    }
  }, [location, language, changeLanguage]);

  return (
    <div className="site-container">
      <TopBar />
      <Header />
      <main className="site-content">
        {children}
      </main>
      <Footer />
      
      {/* Cookie Consent Banner */}
      <CookieConsentBanner />
    </div>
  );
}

export default MainLayout;